import React from 'react'
import { Source, Layer } from 'react-map-gl'
import { circle, Units } from '@turf/turf'
import type { FillLayer } from 'react-map-gl'
import { Coordinates } from '../types'

interface CircleLayerProps {
  radius: number
  coordinates: Coordinates
  /** hex, rgb or CSS color */
  fillColor?: string
  opacity?: number
}

export const CircleLayer: React.FC<CircleLayerProps> = ({ coordinates, radius, fillColor = 'tomato', opacity = 0.1 }) => {
  const units: Units = 'meters'
  const options = { steps: 64, units, properties: { name: 'Geofence' } }
  const position = [coordinates?.longitude, coordinates?.latitude]
  const geojson = circle(position, radius, options)

  const dataLayer: FillLayer = {
    id: 'data',
    type: 'fill',
    paint: {
      'fill-color': fillColor,
      'fill-opacity': opacity
    }
  }

  return (
    <Source id="my-data" type="geojson" data={geojson}>
      <Layer {...dataLayer} />
    </Source>
  )
}
